import  gql  from 'graphql-tag'

export const CREATE_PRODUCT_TYPE = gql`mutation productType($input: ProductTypeMutationInput!){
    productType(input: $input){
        productType{
            id
            code
            name
            isActive
        }
        errors{
            field
            messages
        }
    }
}`;